import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Empty, PortalHeading } from "./PortalLayout";
import { StatusPill } from "@/components/shared/QuoteTypeBadge";
import { useFetch } from "@/hooks/useFetch";
import { api } from "@/lib/api";

export default function Bookings() {
  const { data, reload } = useFetch("/bookings/mine");
  const cancel = async (ref) => { await api.post(`/bookings/${ref}/cancel`); toast.success("Booking cancelled"); reload(); };
  return (
    <div data-testid="portal-bookings">
      <PortalHeading title="Workshop Bookings" action={<Link to="/book" data-testid="bookings-new-button" className="rounded-full bg-[#020165] text-white px-5 py-2.5 text-sm font-semibold">New booking</Link>} />
      {data && !data.bookings.length && <Empty testId="bookings-empty">No bookings yet.</Empty>}
      <div className="space-y-3">
        {data?.bookings.map((b) => (
          <div key={b.reference} className="rounded-2xl bg-white p-5 flex flex-wrap items-center gap-4" data-testid={`booking-card-${b.reference}`}>
            <div className="rounded-xl bg-[#020165] text-white px-4 py-2 text-center"><p className="font-display font-extrabold">{b.scheduled_date}</p><p className="text-[11px] uppercase text-[#F86900]">{b.scheduled_slot}</p></div>
            <div className="flex-1 min-w-[180px]"><p className="font-semibold">{b.service_title}</p><p className="text-sm text-[#56585E]">{b.reference} · {b.vehicle?.make} {b.vehicle?.model} · {b.dropoff_preference === "pickup" ? "Collection" : "Drop-off"}</p></div>
            <StatusPill status={b.status} testId={`booking-status-${b.reference}`} />
            {["requested", "confirmed"].includes(b.status) && <button onClick={() => cancel(b.reference)} data-testid={`booking-cancel-${b.reference}`} className="text-sm underline text-[#56585E]">Cancel</button>}
          </div>
        ))}
      </div>
    </div>
  );
}
